import React from "react";

export default function MySQL_TRUNCATE() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MySQL_TRUNCATE</h1>
      <p>This is the MySQL_TRUNCATE component generated from the SQL JSON.</p>
    </div>
  );
}
